<script setup>
import { ref, onMounted } from 'vue';
import axios from '@/axios';
import AppButton from '@/components/Button/Button.vue';

const sessions = ref(null);

const fetchSessions = () => {
    axios.get('/api/me/sessions').then((res) => {
        sessions.value = res.data.data;
    });
};

const logoutSession = (id) => {
    axios.delete(`/api/me/sessions/${id}`).then(() => {
        fetchSessions();
    });
};

onMounted(fetchSessions);
</script>

<template>
    <layout-content>
        <content-header>
            <top-nav>
                <top-nav-back />
                <top-nav-title>
                    Active Sessions
                </top-nav-title>
            </top-nav>
        </content-header>
        <content-body>
            <div class="p-4">
                <ul v-if="sessions" class="flex flex-col gap-3">
                    <li
                        v-for="session in sessions"
                        :key="session.id"
                        class="border rounded-md p-3 flex justify-between items-center"
                        :class="session.is_current_device ? 'bg-green-50 border-green-400' : ''"
                    >
                        <div>
                            <div class="font-semibold">{{ session.device }} - {{ session.ip_address }}</div>
                            <div class="text-sm opacity-70">Last activity: {{ session.last_activity }}</div>
                            <div v-if="session.is_current_device" class="text-xs opacity-70">This Device</div>
                        </div>
                        <AppButton
                            v-if="!session.is_current_device"
                            type="button"
                            color="danger-border"
                            compact
                            @click="logoutSession(session.id)"
                        >
                            Logout
                        </AppButton>
                    </li>
                </ul>
            </div>
        </content-body>
    </layout-content>
</template>
